/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

// Simple bar
import SimpleBar from 'simplebar-react';

// MetisMenu
import MetisMenu from 'metismenujs';
import { withRouter, Link } from 'react-router-dom';

// i18n
import { withTranslation } from 'react-i18next';

import { Can } from '../../utilities/Can';
import { isDebugUser } from '../../utilities/debugUsers';
import { canAccessUtilities } from '../../helpers/authorization';

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  // componentDidUpdate() {}
  scrollElement = (item) => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current) {
              this.refDiv.current.getScrollElement().scrollTop = currentPosition - 300;
            }
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = (item) => {
    item.classList.add('active');
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== 'side-menu') {
      parent2El.classList.add('mm-show');
    }

    if (parent) {
      parent.classList.add('mm-active');
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add('mm-show'); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add('mm-active'); // li
          parent3.childNodes[0].classList.add('mm-active'); // a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add('mm-show'); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add('mm-show'); // li
              parent5.childNodes[0].classList.add('mm-active'); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  initMenu() {
    // eslint-disable-next-line no-new
    new MetisMenu('#side-menu');
    let matchingMenuItem = null;
    const ul = document.getElementById('side-menu');
    const items = ul.getElementsByTagName('a');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  render() {
    const showDebug = isDebugUser();

    return (
      <SimpleBar className="h-100" ref={this.refDiv}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{this.props.t('Data')}</li>
            <li>
              <Link to="/inventory">
                <i className="bx bx-package" />
                <span>{this.props.t('Items')}</span>
              </Link>
            </li>
            <li>
              <Link to="/kits">
                <i className="mdi mdi-view-dashboard" />
                <span>{this.props.t('Kits')}</span>
              </Link>
            </li>
            <li>
              <Link to="/orders">
                <i className="mdi mdi-cash-register" />
                <span>{this.props.t('Orders')}</span>
              </Link>
              {process.env.REACT_APP_STATIC_INVENTORY !== '1' && (
                <ul className="sub-menu">
                  <li>
                    <Link to="/orders">
                      <span className="mdi mdi-cash-check" />
                      {' '}
                      {this.props.t('External Orders')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/warehouse/internal-orders">
                      <span className="mdi mdi-cart-plus" />
                      {' '}
                      {this.props.t('Internal Orders')}
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            {process.env.REACT_APP_STATIC_INVENTORY !== '1'
              && canAccessUtilities(this.props.user) && (
              <li>
                <Link to="/#">
                  <i className="mdi mdi-forklift" />
                  <span>{this.props.t('Utilities')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/warehouse">
                      <span className="mdi mdi-map-marker" />
                      {' '}
                      {this.props.t('Locations')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/warehouse/map">
                      <span className="mdi mdi-map-outline" />
                      {' '}
                      {this.props.t('Map')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/utilities/boxes">
                      <span className="mdi mdi-package-variant-closed" />
                      {' '}
                      {this.props.t('Boxes')}
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            <li className="menu-title">{this.props.t('Operations')}</li>

            {process.env.REACT_APP_STATIC_INVENTORY !== '1' && (
              <>
                <li>
                  <Link to="/#">
                    <i className="mdi mdi-chart-scatter-plot-hexbin" />
                    <span>{this.props.t('Put-Away')}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/put-away/bins">
                        <i className="mdi mdi-basket-fill" />
                        <span>{this.props.t('Bins')}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/put-away/routes">
                        <i className="mdi mdi-map-marker-distance" />
                        <span>{this.props.t('Routes')}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/put-away/lot-mapping">
                        <i className="mdi mdi-border-top" />
                        <span>{this.props.t('Lot Mapping')}</span>
                      </Link>
                    </li>

                    <li>
                      <Link to="/put-away/consolidate">
                        <i className="mdi mdi-consolidate" />
                        <span>{this.props.t('Consolidate')}</span>
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/warehouse/pickroutes">
                    <i className="mdi mdi-cart-arrow-right" />
                    <span>{this.props.t('Pick')}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/warehouse/inspect">
                    <i className="mdi mdi-monitor-eye" />
                    <span>{this.props.t('Inspect')}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/warehouse/pack/v2">
                    <i className="mdi mdi-package-variant" />
                    <span>{this.props.t('Pack')}</span>
                  </Link>
                </li>
              </>
            )}

            <Can i="see" this="Settings">
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-truck" />
                  <span>{this.props.t('Ship')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/ship">
                      <i className="mdi mdi-truck-fast-outline" />
                      <span>{this.props.t('Ship')}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/settings/ship-method-mappings">
                      <i className="mdi mdi-truck-fast-outline" />
                      <span>{this.props.t('Methods Mapping')}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </Can>

            <Can not i="see" this="Settings">
              <li>
                <Link to="/ship">
                  <i className="mdi mdi-truck-fast-outline" />
                  <span>{this.props.t('Ship')}</span>
                </Link>
              </li>
            </Can>

            <Can i="see" this="Settings">
              <li className="menu-title">{this.props.t('Setup')}</li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-cog" />
                  <span>{this.props.t('Settings')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/printers">
                      <i className="mdi mdi-printer-settings" />
                      <span>{this.props.t('Printers')}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/settings/scanners">
                      <i className="mdi mdi-scanner" />
                      <span>{this.props.t('Scanners')}</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/users">
                      <i className="bx bxs-contact" />
                      <span>{this.props.t('Users')}</span>
                    </Link>
                  </li>

                  {showDebug && (
                    <li>
                      <Link to="/debug">
                        <i className="mdi mdi-bug-outline" />
                        <span>{this.props.t('Debug')}</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="mdi mdi-api" />
                  <span>{this.props.t('Remote Services')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/microsoft">
                      <span className="mdi mdi-microsoft" />
                      {' '}
                      {this.props.t('Microsoft')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/slack">
                      <span className="fab fa-slack" />
                      {' '}
                      {this.props.t('Slack')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/client-api">
                      <span className="mdi mdi-application" />
                      {' '}
                      {this.props.t('Client Api')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/fedex">
                      <span className="mdi mdi-application" />
                      {' '}
                      {this.props.t('FedEx')}
                    </Link>
                  </li>
                  <li>
                    <Link to="/ship/payonuse">
                      <span className="mdi mdi-application" />
                      {' '}
                      {this.props.t('USPS Pay-On-Use')}
                    </Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bxs-book-open" />
                  <span>{this.props.t('Logs')}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/logs/audit-trail">{this.props.t('Audit Trail')}</Link>
                  </li>
                  <li>
                    <Link to="/logs/exceptions">{this.props.t('Exceptions')}</Link>
                  </li>
                  <li>
                    <Link to="/logs/shipping-exceptions">{this.props.t('Shipping Exceptions')}</Link>
                  </li>
                  <li>
                    <Link to="/logs/scrap">{this.props.t('Scrap')}</Link>
                  </li>
                </ul>
              </li>
            </Can>
          </ul>
        </div>
      </SimpleBar>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.Login.user,
});

export default connect(mapStateToProps)(withRouter(withTranslation()(SidebarContent)));
